import Vue from "vue";
import VueRouter from "vue-router";
import Router from "vue-router";
Vue.use(VueRouter);
Vue.use(Router);
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
// const routesP = [{
// path: '/',
// name: 'Index',
// component: () => import( /* webpackChunkName: “about” */'@/views/pc/Index.vue')
// }]
const routesP = [
  // {
  // path: '/',
  // name: 'Index',
  // component: () => import( /* webpackChunkName: “about” */'@/views/pc/Index.vue')
  // }
  {
    path: "/Index/Index",
    redirect: `/Index`,
  },
  {
    path: "/",
    redirect: `/Index`,
  },
  {
    path: "/",
    name: "home",
    component: () => import("./views/pc/Home"),
    children: [
      {
        path: '/Index',//首页
        name: 'Index',
        component: () => import("./views/pc/Index"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/StartBuilding", //开始建造
        name: "StartBuilding",
        component: () => import("./views/pc/Developer/StartBuilding.vue"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Overview", //Overview
        name: "Overview",
        component: () => import("./views/pc/Learning/Overview.vue"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Wallet", //钱包
        name: "Wallet",
        component: () => import("./views/pc/Learning/Wallet.vue"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Ecological", //生态发展
        name: "Ecological",
        component: () => import("./views/pc/Ecological.vue"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Application", //合约(募资)
        name: "Application",
        component: () => import("./views/pc/Application.vue"),
        meta: {
          alive: false,
        },
      },
      {
        path: "/Index/Applicationa", //合约12步骤
        name: "Applicationa",
        component: () => import("./views/pc/Applicationa.vue"),
        meta: {
          alive: false,
        },
      },
      {
        path: "/Index/Applicationb", //合约12步骤
        name: "Applicationb",
        component: () => import("./views/pc/Applicationb.vue"),
        meta: {
          alive: false,
        },
      },{
        path: "/Index/Ambassadors", //合约12步骤
        name: "Applicationc",
        component: () => import("./views/pc/Applicationc.vue"),
        meta: {
          alive: false,
        }        
      } , {
        path: "/Index/Applicationd", //合约12步骤
        name: "Applicationd",
        component: () => import("./views/pc/Applicationd.vue"),
        meta: {
          alive: false,
        },
      },
      {
        path: "/Index/Ambassador", //合约12步骤
        name: "Ambassador",
        component: () => import("./views/pc/Ambassador/Flow.vue"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Ambassadora", //合约12步骤
        name: "Ambassador",
        component: () => import("./views/pc/Ambassador/Flowa.vue"),
        meta: {
          alive: false,
        },
      },
      {
        path: "/Index/Ambassadorb", //合约12步骤
        name: "Ambassador",
        component: () => import("./views/pc/Ambassador/Flowb.vue"),
        meta: {
          alive: false,
        },
      },
      {
        path: "/Index/Brand", //品牌工具包
        name: "Ambassador",
        component: () => import("./views/pc/Brand/Brand.vue"),
        meta: {
          alive: true,
        },
      },
      // {
      //   path: "/Index/Ranking", //品牌工具包
      //   name: "ranking",
      //   component: () => import("./views/pc/ranking/ranking.vue"),
      //   meta: {
      //     alive: true,
      //   },
      // },
      // {
      //   path: "/Index/LotteryRecord", //抽奖记录
      //   name: "LotteryRecord",
      //   component: () => import("./views/pc/LotteryRecord/lottery.vue"),
      //   meta: {
      //     alive: true,
      //   },
      // },
      // {
      //   path: "/Index/Integral", //抽奖记录
      //   name: "Integral",
      //   component: () => import("./views/pc/Integral/Integral.vue"),
      //   meta: {
      //     alive: true,
      //   },
      // },
      {
        path: "/Index/Round", //抽奖记录
        name: "Round",
        component: () => import("./views/pc/Round/Round.vue"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Address", //抽奖记录
        name: "Address",
        component: () => import("./views/pc/Address/Address.vue"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/MintNFT", //抽奖记录
        name: "MintNFT",
        component: () => import("./views/pc/MintNFT/Mintnft.vue"),
        meta: { alive: true }
      },
      // {
      //   path: "/Index/Test", //抽奖记录
      //   name: "MintNFT",
      //   component: () => import("./views/pc/MintNFT/test.vue"),
      //   meta: { alive: true }
      // }
    ],
  },
  
];

const routesM = [
  {
    path: "/Index/Index",
    redirect: `/Index`,
  },
  {
    path: "/",
    redirect: `/Index`,
  },
  {
    path: "/",
    name: "Index",
    component: () =>
      import(/* webpackChunkName: “about” */ "@/views/m/Index.vue"),
  },
  {
    path: '/Index',
    name: 'home',
    component: () => import('./views/m/Home'),
    children: [
      {
        path: '/Index',
        name: 'Index',
        component: () => import('./views/m/Index'),
        meta: {
          alive: true,
        },
      }, 
      {
        path: "/Index/StartBuilding",
        name: "StartBuilding",
        component: () => import("./views/m/Learning/building"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Overview",
        name: "Overview",
        component: () => import("./views/m/Learning/Overview"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Wallet",
        name: "Wallet",
        component: () => import("./views/m/Learning/Wallet"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Ecological",
        name: "Ecological",
        component: () => import("./views/m/Learning/Ecological"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Application", //资金申请第三步
        name: "Application",
        component: () => import("./views/m/Application/Application"),
        meta: {
          alive: false,
        },
      
      },
      {
        path: "/Index/Applicationa", //资金申请第三步
        name: "Applicationa",
        component: () => import("./views/m/Application/Applicationa"),
        meta: {
          alive: false,
        },
      
      },
      {
        path: "/Index/Ambassadors", //资金申请第三步
        name: "Ambassadors",
        component: () => import("./views/m/Application/Applicationc"),
        meta: {
          alive: false,
        },
      
      },
      {
        path: "/Index/Applicationb", //资金申请第三步
        name: "Applicationb",
        component: () => import("./views/m/Application/Applicationb"),
        meta: {
          alive: false,
        },
      
      },
      {
        path: "/Index/Applicationd", //资金申请第三步
        name: "Applicationd",
        component: () => import("./views/m/Application/Applicationd"),
        meta: {
          alive: false,
        },
      
      },
      {
        path: "/Index/Ambassador", //资金申请第三步
        name: "Ambassador",
        component: () => import("./views/m/Ambassador/Ambassador"),
        meta: {
          alive: true,
        },
      
      },
      {
        path: "/Index/Ambassadora", //资金申请第三步
        name: "Ambassadora",
        component: () => import("./views/m/Ambassador/Ambassadora"),
        meta: {
          alive: false,
        },
      },
      {
        path: "/Index/Ambassadorb", //资金申请第三步
        name: "Ambassadorb",
        component: () => import("./views/m/Ambassador/Ambassadorb"),
        meta: {
          alive: false,
        },
      },
      {
        path: "/Index/Brand", //资金申请第三步
        name: "Brand",
        component: () => import("./views/m/Brand/Brand"),
        meta: {
          alive: true,
        },
      },
      // {
      //   path: "/Index/Ranking", //品牌工具包
      //   name: "ranking",
      //   component: () => import("./views/m/Ranking/ranking.vue"),
      //   meta: {
      //     alive: true,
      //   },
      // },
      // {
      //   path: "/Index/LotteryRecord", //抽奖记录
      //   name: "LotteryRecord",
      //   component: () => import("./views/m/LotteryRecord/lottery.vue"),
      //   meta: {
      //     alive: true,
      //   },
      // },
      // {
      //   path: "/Index/Integral", //抽奖记录
      //   name: "Integral",
      //   component: () => import("./views/m/Integral/Integral.vue"),
      //   meta: {
      //     alive: true,
      //   },
      // },
      {
        path: "/Index/Round", //抽奖记录
        name: "Round",
        component: () => import("./views/m/Round/Round.vue"),
        meta: {
          alive: true,
        },
      },
      {
        path: "/Index/Address", //抽奖记录
        name: "Address",
        component: () => import("./views/m/Address/Address.vue"),
        meta: {
          alive: true,
        },
      }
    ],
  },
];

var routes = [];
if (
  navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
) {
  routes = routesM;
} else {
  routes = routesP;
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
